import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { OnboardingLayout } from "./OnboardingLayout";
import { Button, ProgressBar } from "@/components";
import { useUserStore } from "@/store";
import { trackSyncCompleted, trackOnboardingCompleted } from "@/services/analytics";
import styles from "./Onboarding.module.css";

export function Syncing() {
  const navigate = useNavigate();
  const { syncStatus, syncProgress, completeOnboarding, pollSyncProgress } = useUserStore();

  const isDone = syncStatus === "done";
  const isError = syncStatus === "error";

  // If we arrive here and sync hasn't started polling yet, kick it off
  useEffect(() => {
    pollSyncProgress();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isDone) {
      trackSyncCompleted(syncProgress);
    }
  }, [isDone, syncProgress]);

  function handleLaunch() {
    trackOnboardingCompleted();
    completeOnboarding();
    navigate("/closet");
  }

  function handlePreview() {
    trackOnboardingCompleted();
    completeOnboarding();
    navigate("/closet");
  }

  return (
    <OnboardingLayout currentStep={4} totalSteps={4}>
      <h2 className={styles.stepTitle}>Syncing your purchases</h2>
      <div className={styles.syncWrap}>
        <div className={[styles.syncRing, isDone ? styles.syncRingDone : ""].filter(Boolean).join(" ")} />
        <div className={styles.syncCount}>{Math.round(syncProgress || 0)}%</div>
        <div className={styles.syncSub}>{isError ? "Something went wrong" : "of purchase history analyzed so far."}</div>
        <div className={styles.syncProgress}>
          <ProgressBar
            percent={syncProgress}
            label={
              isDone
                ? "Sync complete!"
                : isError
                  ? "Sync failed — you can still preview your closet"
                  : `Scanning receipts...`
            }
          />
        </div>
      </div>
      <div className={styles.syncBtns}>
        <Button disabled={!isDone && !isError} onClick={handleLaunch}>
          {isDone ? "Let's Go" : isError ? "Continue Anyway" : "Waiting..."}
        </Button>
        {!isDone && !isError && (
          <Button variant="secondary" onClick={handlePreview}>
            Start Previewing Closet
          </Button>
        )}
      </div>
    </OnboardingLayout>
  );
}
